import React from 'react';
import { styled, useTheme } from '@mui/material/styles';

const withStyles = (styles) => (Component) => {
  return (props) => {
    const theme = useTheme();
    const StyledComponent = styled(Component)(({ theme }) => {
      const themeStyles = typeof styles === 'function' ? styles(theme) : styles;
      return themeStyles;
    });

    const classes = {};
    const themeStyles = typeof styles === 'function' ? styles(theme) : styles;
    Object.keys(themeStyles).forEach(key => {
      classes[key] = `mui-${key}`;
    });

    return <StyledComponent {...props} classes={classes} theme={theme} />;
  };
};

export default withStyles;